<template>
    <frontend-layout>
        <div class="bg-[#F1FAFF]">
            <div class="max-w-[1440px] mx-auto w-full p-[16px] justify-center align-center text-center leading-[26px]">
                Need CE? We also operate <a href="https://emt-ce.com" class="text-blue-500">EMT-CE.com</a>
                where we offer recertification and remedial packages for all levels
            </div>
        </div>
        <div>
            <div
                class="bg-[url(/assets/art/critical-judgment-header.jpg)] bg-center bg-no-repeat bg-cover flex flex-col">
                <div class="px-[20px]"
                     style="background:rgba(0,0,0,0.6); box-shadow: inset 0px -123px 76px 0px rgba(0,0,0,0.75);">
                    <div class="max-w-[1440px] mx-auto">
                        <div class="pt-[16rem] w-full max-w-[80%] md:max-w-[750px] lg:pt-[8rem] lg:pl-[6rem]">
                            <p class="text-[32px] md:text-[64px] font-bold text-white leading-[56px] md:leading-[78px] text-left">
                                Updated to the latest
                                <span class="text-secondary-500">NREMT</span> standards
                                <inline-svg
                                    class="inline-block relative mx-auto"
                                    src="/assets/art/exclamation.svg"
                                ></inline-svg>
                            </p>
                        </div>
                        <div class="pt-8 lg:max-w-[550px] lg:pl-[6rem]">
                            <p class="text-[20px] leading-[35px] text-white lg:text-[24px]">EMTPrep is proud to bring
                                you clinical judgment scenarios just like you'll see on test day.</p>
                        </div>
                        <p class="flex flex-row justify-center pt-4 pb-8 lg:justify-start lg:pb-[8rem] lg:pl-[6rem]">
                            <Link
                                :href="route('frontend.pricing')"
                                class="btn btn-lg btn-primary w-full text-center lg:w-auto lg:sef-start"
                            >
                                Get started for $39/month
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-neutral-10">
            <div class="px-[20px] pt-16  pb-8 max-w-[1440px] mx-auto lg:px-[100px]">
                <p class="text-[36px] leading-[56px] font-semibold tracking-[-1.08px] pb-[2rem] md:text-center">Updated
                    NREMT Standards: Clinical <span
                        class="handwritten-underline-auto pb-[5px]">Judgment Scenarios</span>
                </p>
                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                    <p class="text-[20px] md:text-[24px] leading-[45px] tracking-[-0.72px] font-light md:w-5/12">On July
                        1, 2024 the
                        NREMT updated the AEMT and Paramedic cognitive exams and added a new domain called Clinical
                        Judgment Scenarios.</p>
                    <img src="/assets/art/nremt.png" class="h-[200px] w-[200px] mx-auto md:mr-8 md:ml-20"/>
                    <div class="w-full md:w-4/12 flex flex-col items-center justify-center">
                        <p class="text-[20px] leading-[35px] font-light w-[200px] mx-auto md:mx-0 pt-12 md:pt-0">For
                            more details
                            visit our resources page: </p>
                        <Link href="/resources" class="mx-auto text-purple-500 underline font-light md:mx-0">
                            emtprep.com/resources
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div
                class="px-[20px] w-full max-w-[1440px] text-[20px] font-normal flex flex-col py-[3rem] md:flex-row md:mx-auto md:gap-8 md:px-[100px] md:justify-between">
                <img src="/assets/art/ambulance-nurse.jpg" class="md:w-7/12"/>
                <div class="flex flex-col md:w-5/12">
                    <p class="text-[36px] font-semibold leading-[48px] tracking-[-.72px] pt-8 pb-4">Cognitive Exam
                        Changes</p>
                    <p class="text-[24px] leading-[35px] font-light">As of July 1, 2024 the NREMT has made drastic
                        changes to their certifications exams for the AEMT and Paramedic levels. A brand new domain will
                        be assessed, known as clinical judgment.</p>
                </div>
            </div>
        </div>
        <div class="bg-neutral-10">
            <div class="px-[20px] pt-[60px] flex flex-col w-full max-w-[1440px] md:mx-auto">
                <div class="flex flex-col">
                    <p class="text-[36px] leading-[48px] font-semibold tracking-[-0.72px] pb-[1rem] md:text-center">New
                        Question Phases</p>
                    <p class="text-[24px] leading-[35px] font-light md:text-center md:w-[800px] md:mx-auto">Clinical
                        judgment questions are made
                        up of 9-18 questions that cover the three major phases to EMS calls: </p>
                </div>
                <div class="flex flex-col md:flex-row md:justify-center md:pt-16">
                    <div class="flex flex-col md:h-[800px] md:pr-24">
                        <div class="pt-8">
                            <p class="text-center text-[32px] font-semibold leading-[48px] tracking-[-.72px] md:text-[18px] md:leading-[20px]">
                                Phase 1:</p>
                            <inline-svg
                                class="inline-block relative mx-auto h-[150px] md:w-[200px] md:h-[175px]"
                                src="/assets/art/phase-1.svg"
                            ></inline-svg>
                        </div>
                        <div class="pt-8">
                            <p class="text-center text-[32px] font-semibold leading-[48px] tracking-[-.72px] md:text-[18px] md:leading-[20px]">
                                Phase 2:</p>
                            <inline-svg
                                class="inline-block relative mx-auto h-[150px] md:w-[200px] md:h-[175px]"
                                src="/assets/art/phase-2.svg"
                            ></inline-svg>
                        </div>
                        <div class="pt-8">
                            <p class="text-center text-[32px] font-semibold leading-[48px] tracking-[-.72px] md:text-[18px] md:leading-[20px]">
                                Phase 3:</p>
                            <inline-svg
                                class="inline-block relative mx-auto md:w-[200px] h-[200px]"
                                src="/assets/art/phase-3.svg"
                            ></inline-svg>
                        </div>
                    </div>
                    <div
                        class="flex flex-col pt-[100px] pb-[60px] text-[32px] font-medium leading-[48 px] md:text-[40px] md:pt-8">
                        <div class="pb-[58px]">Recognize cues</div>
                        <div class="pb-[58px]">Evaluation</div>
                        <div class="pb-[58px]">Take action</div>
                        <div class="pb-[58px]">Generate solutions</div>
                        <div class="pb-[58px]">Define hypothesis</div>
                        <div class="pb-[58px]">Analyze cues</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-gray-800">
            <div
                class="px-[20px] py-[4rem] mx-auto flex flex-col md:flex-row-reverse md:max-w-[1440px] md:px-[100px] md:gap-16 md:justify-between">
                <div class="flex flex-col pb-[20px]">
                    <p class="text-secondary-500 text-[32px] leading-[48px] tracking-[-0.64px] pb-4 md:max-w-[400px]">
                        “What kind of
                        questions will I be asked?”</p>
                    <ul class="text-white list-disc pl-4 grow">
                        <li class="leading-[48px] tracking-[-0.48px]">Multiple choice</li>
                        <li class="leading-[48px] tracking-[-0.48px]">Multiple response</li>
                        <li class="leading-[48px] tracking-[-0.48px]">Drag-and-drop</li>
                        <li class="leading-[48px] tracking-[-0.48px]">Graphical</li>
                        <li class="leading-[48px] tracking-[-0.48px]">List building (sequential ordering)</li>
                    </ul>
                </div>
                <div class="flex items-center justify-center md:w-7/12">
                    <div class="aspect-video w-full shadow-lg ">
                        <video-player video-token="VLkbon9P"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-only-gradient">
            <div
                class="px-[20px] py-[4rem] mx-auto flex flex-col md:flex-row md:max-w-[1440px] md:px-[100px] md:gap-16 md:justify-between">
                <div class="flex flex-col pb-[20px] md:w-1/2">
                    <p class="text-[36px] font-semibold leading-[48px] tracking-[-0.72px] pt-8 pb-4">Question
                        Formatting</p>
                    <p class="text-[24px] font-light leading-[45px]">EMTPrep is proud to offer the same formatting and
                        layout that you’ll see on test day for every question type you’re likely going to see.</p>
                </div>
                <img src="/assets/art/multiple_choice_questions1.png" class="shadow-lg w-full md:w-7/12"/>
            </div>
        </div>
        <div class="bg-neutral-10">
            <div
                class="px-[20px] py-[4rem] mx-auto flex flex-col md:flex-row md:max-w-[1440px] md:px-[100px] md:gap-16 md:justify-between">
                <img src="/assets/art/paramedic.jpg" class="md:w-7/12"/>
                <div class="flex flex-col md:w-5/12">
                    <p class="text-[36px] font-semibold leading-[48px] tracking-[-0.72px] pt-8 pb-4">Start Prepping
                        Today</p>
                    <p class="text-[20px] font-light leading-[35px]">Don't sleep on this update! You'll be required to
                        show your knowledge in a new way on test day and you'll need to be familiar with the material
                        and formatting if you want to be successful on your exam. Our questions are designed
                        specifically like the NREMT so you can know what to expect when facing clinical judgment
                        scenarios on test day.</p>
                </div>
            </div>
        </div>
        <div class="bg-gray-800 md:p-[100px]">
            <div class="px-[60px] mx-auto flex flex-col w-full py-8 md:max-w-[1240px] md:px-[100px]">
                <p class="text-white text-[40px] font-semibold leading-[52px] tracking-[-1.2px] text-center pb-[5rem] md:w-[650px]   md:text-[48px] md:leading-[56px] md:mx-auto">
                    Ready to take your test prep to the NE<span class="handwritten-underline-auto -mb-4">XT level</span>
                    <inline-svg
                        class="inline-block relative mx-auto mb-3 px-1 w-[36px]"
                        src="/assets/art/questionmark.svg"
                    ></inline-svg>
                </p>
                <Link
                    :href="route('frontend.pricing')"
                    class="btn btn-lg btn-primary w-full text-center lg:self-start lg:w-auto lg:mx-auto"
                >
                    Get started for $39/month
                </Link>
            </div>
        </div>

    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout.vue";
import VideoPlayer from "@/Components/VideoPlayer.vue";

export default {
    name: "CriticalJudgment",
    components: {FrontendLayout, VideoPlayer}
}
</script>
